import { render, staticRenderFns } from "./TradeSearch.vue?vue&type=template&id=1e48a62c&scoped=true&"
import script from "./TradeSearch.vue?vue&type=script&lang=js&"
export * from "./TradeSearch.vue?vue&type=script&lang=js&"
import style0 from "./TradeSearch.vue?vue&type=style&index=0&id=1e48a62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48a62c",
  null
  
)

export default component.exports